import { render, staticRenderFns } from "./wheelLuck.vue?vue&type=template&id=765b942d&scoped=true&"
import script from "./wheelLuck.vue?vue&type=script&lang=js&"
export * from "./wheelLuck.vue?vue&type=script&lang=js&"
import style0 from "./wheelLuck.vue?vue&type=style&index=0&id=765b942d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b942d",
  null
  
)

export default component.exports